import { Fractions } from '@ezchops/helpers';
import { range } from 'lodash';
import { isChordTuplet } from '../sheet';
export function sheetToGrid(sheet) {
    const resolution = sheetResolution(sheet);
    const initialGrid = { ticks: [], lastTick: 0, resolution };
    return sheet.segments.reduce(reduceSegment, initialGrid);
}
function reduceSegment(initialGrid, segment) {
    const resolution = initialGrid.resolution;
    if (resolution < segment.signature.denominator) {
        throw new Error(`Cannot generate 1/${resolution} grid from ${segment.signature.numerator}/${segment.signature.denominator} sheet`);
    }
    return range(((segment.repeats ?? 0) + 1)).reduce((grid) => segment.measures.reduce(reduceMeasure, grid), initialGrid);
}
export function segmentGrid(segment, resolution, offset) {
    return reduceSegment({ ticks: [], lastTick: offset, resolution }, segment);
}
export function measureGrid(measure, resolution, offset) {
    return reduceMeasure({ ticks: [], lastTick: offset, resolution }, measure);
}
export function sheetResolution(sheet) {
    return Math.max(...sheet.segments.map(segmentResolution));
}
export function segmentResolution(segment) {
    const tickDurations = segment.measures
        .flatMap(({ notes }) => notes.map(tickDuration))
        .map(([n, d]) => Fractions.reduce(n, d));
    if (tickDurations.length == 0) {
        return segment.signature.denominator;
    }
    return Math.max(Fractions.commonDenominator(...tickDurations), segment.signature.denominator);
}
export function tickDuration(note) {
    if (isChordTuplet(note)) {
        return [note.duration[0], note.duration[1] * note.chords.length];
    }
    else {
        return withDots(note.duration, note.dots ?? 0);
    }
}
export function withDots([n, d], dots) {
    return dots == 0 ? [n, d] : withDots([n * 2 + 1, d * 2], dots - 1);
}
function reduceMeasure(initialGrid, measure) {
    const resolution = initialGrid.resolution;
    return measure.notes.reduce((state, note) => {
        return isChordTuplet(note)
            ? reduceTuplet(note, state)
            : reduceChord(note, state);
    }, initialGrid);
    function reduceTuplet(tuplet, grid) {
        const [numerator, denominator] = tickDuration(tuplet);
        const duration = (numerator * resolution / denominator);
        const ticks = tuplet.chords.map((notes, i) => ({
            notes,
            tick: grid.lastTick + (i * duration)
        })).filter(({ notes }) => notes.length > 0);
        return {
            ticks: [...grid.ticks, ...ticks],
            lastTick: grid.lastTick + duration * tuplet.chords.length,
            resolution
        };
    }
    function reduceChord(chord, grid) {
        const [numerator, denominator] = tickDuration(chord);
        const duration = (numerator * resolution / denominator);
        if (duration < 1) {
            throw new Error('Higher resolution needed');
        }
        const ticks = chord.notes.length > 0
            ? [{ tick: grid.lastTick, notes: chord.notes }]
            : [];
        return {
            ticks: [...grid.ticks, ...ticks],
            lastTick: grid.lastTick + duration,
            resolution
        };
    }
}
//# sourceMappingURL=sheetToGrid.js.map